
import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import useTranslation from '../../../Hooks/UseTranslation'
import { useProgrammation } from '../../../Hooks/UseProgrammation'

import { setTaskWork, updateTaskParentId } from '../../../Services/ProgrammationManagerService'
import { getItemAndItsParentFromTaskList, getTasksOptionsFromTaskList } from '../../../Helpers/ProgrammationHelper'
import { updateTaskParentIdAction } from '../../../Redux/Actions/ProgrammationManagerActions'

import InputSelect from '../components/InputSelect'

interface Props {
  task: any
  taskList: any[]
}

const TaskParent = ({ task, taskList }: Props) => {

  const { t } = useTranslation()

  const { setEditingItem, openItem, patchItemOpened } = useProgrammation()

  const dispatch = useDispatch()

  const macroResult = useSelector((state: any) => state.MacroReducer.result)

  const [ parentId, setParentId ] = useState(task.parentId || '')
  const [ tasksOptions, setTasksOptions ] = useState<any[]>([])

  const handleChangeParentId = async (parentId: string) => {

    setParentId(parentId)

    setEditingItem(true)

    let error
    let data

    if (!task.parentId) {

      const res = await setTaskWork(task._id, parentId)

      error = res[0]
      data = res[1]
    } else {

      const res = await updateTaskParentId(task._id, parentId, task.project)

      error = res[0]
      data = res[1]
    }

    setEditingItem(false)
    if (error) {
      return;
    }

    const { parentTask } = data

    patchItemOpened({
      parentId: parentTask._id,
      parentName: parentTask.name,
      parentPosition: parentTask.position,
      parentType: 'partida',
    })

    await dispatch(updateTaskParentIdAction(data))
  }

  useEffect(() => {

    const tasksOptions = getTasksOptionsFromTaskList(taskList, task, 0, t('RELATIONS_LIST:NamelessTask'))
    setTasksOptions(tasksOptions)

  }, [taskList])

  return (
    <Form.Group>
      <Form.Label>
        {t('PROGRAMMATION_MANAGER:ParentLabel')}
      </Form.Label>
      <Row>
        <Col>
          <InputSelect
            value={parentId}
            onChange={handleChangeParentId}
            placeholder={t('PROGRAMMATION_MANAGER:SelectPlaceholder')}
            options={tasksOptions}
            renderOption={(option: any) => (
              <option value={option.value}>
                {option.label}
              </option>
            )}
          />
        </Col>
      </Row>
    </Form.Group>
  )
}

export default TaskParent
